const faqs = [
  {
    q: 'What is Vigorbuy Spreadsheet?',
    a: 'Vigorbuy Spreadsheet is a powerful spreadsheet platform designed for business management, financial tracking, inventory control, and data organization. It combines an intuitive interface with advanced features like automated calculations, customizable templates, real-time collaboration, and seamless cloud synchronization — making it an ideal choice for professionals, small business owners, and teams looking to streamline their data workflows.',
  },
  {
    q: 'Is Vigorbuy Spreadsheet safe to use?',
    a: 'Yes, Vigorbuy Spreadsheet is built with security in mind. The platform employs data encryption, secure access controls, and privacy protections to keep your information safe. As with any online tool, we recommend using strong passwords, enabling two-factor authentication where available, regularly backing up important files, and only downloading spreadsheet files from trusted official sources.',
  },
  {
    q: 'How does Vigorbuy Spreadsheet work?',
    a: 'Vigorbuy Spreadsheet works similarly to traditional spreadsheet applications but with enhanced business-focused features. You create or open spreadsheets in your browser, organize data into rows and columns, apply formulas and functions for calculations, create charts for data visualization, and share files with team members for real-time collaboration. The platform supports importing and exporting data in multiple formats for maximum compatibility.',
  },
  {
    q: 'What are the best Vigorbuy Spreadsheet templates?',
    a: 'The best templates depend on your specific needs. Popular options include the Business Budget Template for financial planning, the Inventory Management Template for stock tracking, the Sales Dashboard Template for revenue analysis, the Project Timeline Template for task management, and the Expense Report Template for cost tracking. Each template comes pre-formatted with formulas and can be customized to match your workflow.',
  },
  {
    q: 'Can Vigorbuy Spreadsheet replace Excel or Google Sheets?',
    a: 'Vigorbuy Spreadsheet offers unique advantages for business users, including specialized templates, enhanced automation capabilities, and business-focused features that go beyond standard spreadsheet tools. While Excel and Google Sheets remain excellent general-purpose options, Vigorbuy Spreadsheet is specifically optimized for business management scenarios like inventory tracking, financial planning, and team collaboration — making it a strong complement or alternative depending on your needs.',
  },
  {
    q: 'How do I get started with Vigorbuy Spreadsheet?',
    a: 'Getting started is straightforward. Visit the official Vigorbuy Spreadsheet website at kaspreadsheet.com, create your account, and explore the template library to find resources matching your needs. We recommend starting with a pre-built template for your specific use case, then customizing it as you become more familiar with the platform. Our complete guide provides step-by-step instructions for beginners.',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide mb-4">
            FAQ
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto">
            Find answers to the most common questions about Vigorbuy Spreadsheet.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 border border-background-200/60 rounded-2xl overflow-hidden">
              <summary className="px-6 py-5 flex items-center justify-between cursor-pointer list-none">
                <h3 className="text-base font-semibold text-foreground-900 pr-4">{faq.q}</h3>
                <div className="w-8 h-8 rounded-lg bg-background-100 flex items-center justify-center flex-shrink-0 group-open:bg-primary-100 transition-colors">
                  <i className="ri-add-line text-foreground-600 group-open:hidden text-sm"></i>
                  <i className="ri-subtract-line text-primary-600 hidden group-open:block text-sm"></i>
                </div>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}